import { IUnderwriterRemittanceResponse } from '../../../types/order/escrow/IUnderwriterRemittanceResponse';
import { IUnderwriterRemittanceData } from '../../../types/order/escrow/IUnderwriterRemittanceData';

export const convertUnderwriterRemittanceResponseToUnderwriterRemittanceData: (
  response: IUnderwriterRemittanceResponse
) => IUnderwriterRemittanceData = (response) => ({
  ...response,
});
